module.exports = __webpack_public_path__ + "img/bg_avatar_male_35.8f32c38e.png";